import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './search-result-detailed-row.scss';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { viewWordDocument, viewPowerpointDocument, excelDocumentActions, setDocPath, fetchDocumentStart, fetchDocumentFinish } from '../../../redux/tasks/task-actions';
import DocumentViewer from '../../../components/documentViewer/documentViewer';
import DocumentViewerPowerpoint from '../../../components/documentViewerPowerpoint/documentViewerPowerpoint';
import ViewMembersPanelNew from "../../../components/view-members-new/view-members-new";
import FluentUiIcon from "../../../assets/fluent-ui-icon";
import { selectUserID, selectToken } from '../../../redux/user/user-selector';
import { GetDocumentPDF } from '../../../services/api/document-api';

export const GetIcon = (name) => {
    let type = "";
    let title = "";
    let color = '';
    
    switch (name) {
        case "xls":
            type = "DocumentTableRegular";
            title = "MS Excel document";
            break;
        case "ppt":
            type = "ChartMultipleRegular";
            title = "MS PowerPoint document";
            break;
        case "doc":
            type = "DocumentBulletListRegular";
            title = "MS Word document";
            break;
        case "project":
            type = "FolderFilled";
            title = "Project";
            color = "#0E75BB";
            break;
        case "task":
            type = "ClipboardTextEditFilled";
            title = "Standard Task";
            color = "#d8368d";
            break;
        default:
            break;
    }

    return {
        iconImage: <FluentUiIcon name={type} color={color} />,
        iconTitle: title
    };
};  

const SearchResultDetailedRow = ({ result }) => {
    const history = useHistory();
    const [icon, setIcon] = useState({ iconImage: '', iconTitle: '' });
    const [viewType, setViewType] = useState('');
    const [documentViewerType, setDocumentViewerType] = useState('');
    const [showDocumentViewer, setShowDocumentViewer] = useState(false);
    const [showDocumentViewerPowerpoint, setShowDocumentViewerPowerpoint] = useState(false);
    
    const dispatch = useDispatch();
    const userID = useSelector(selectUserID);
    const token = useSelector(selectToken);

    useEffect(() => {
        if (result.Doc) {
            if (result.DocumentType.includes('Word')) {
                setIcon(GetIcon("doc"));
            } else if (result.DocumentType.includes('PowerPoint')) {
                setIcon(GetIcon("ppt"));
            } else if (result.DocumentType.includes('Excel')) {
                setIcon(GetIcon("xls"));
            }
        } else if (result.Type === 'Project') {
            setIcon(GetIcon("project"));
        } else if (result.Type === 'Regular Task') {
            setIcon(GetIcon("task"));
        } else if (result.DocumentType.includes('Word')) {
            setIcon(GetIcon("doc"));
        } else if (result.DocumentType.includes('PowerPoint')) {
            setIcon(GetIcon("ppt"));
        } else if (result.DocumentType.includes('Excel')) {
            setIcon(GetIcon("xls"));
        }
    }, [result]);

    useEffect(() => {
        if (result.Doc && (viewType === 'View Content')) {
            getDocumentPdf();
            setDocumentViewerType('');
            setShowDocumentViewer(true);
            setViewType('');
        } else if (result.Type === 'Project' && (viewType === 'View Content')) {
            history.push(`/projects/view/${result.Id}`);
        } else if (result.Type === 'Regular Task' && (viewType === 'View Content')) {
            let location = {
                pathname: `/tasks/view/std/${result.Id}`,
                state: {
                    buttons: [],
                    approve: true,
                    decline: true,
                    cancel: false,
                }
            }
            history.push(location);
        } else if (result.Type === 'Document Task' && (viewType === 'View Content')) {
            switch (result.DocumentType) {
                case 'Word':
                    dispatch(viewWordDocument(result.Id, 'Assigned Content'));
                    setDocumentViewerType('Assigned Content');
                    setShowDocumentViewer(true);
                    setViewType('');
                    break;
                case 'PowerPoint':
                    dispatch(viewPowerpointDocument(result.Id));
                    setShowDocumentViewerPowerpoint(true);
                    setViewType('');
                    break;
                case 'Excel':
                    let payloadExcel = {
                        docDocument: {
                            documentName: result.Link,
                        },
                        assignID: result.Id
                    }
                    dispatch(excelDocumentActions(payloadExcel, 'Assigned Content', userID, token, null));
                    setDocumentViewerType('Assigned Content');
                    setViewType('');
                    setShowDocumentViewer(true);
                    break;
                default:
                    return setViewType('');
            }
        }
    }, [viewType]);

    const viewResult = () => {
        setViewType('View Content');
    }

    const getDocumentPdf = async () => {
        try {
            dispatch(fetchDocumentStart());
            const docPath = await GetDocumentPDF(result.Link);
            dispatch(setDocPath(docPath));
            dispatch(fetchDocumentFinish());
        } catch (error) {
            dispatch(fetchDocumentFinish());
            console.log(error);
        }
    }

    return (
        <tr className='search-results-row-container'>
            <td className='search-results-name'>
                <div dangerouslySetInnerHTML={{ __html: result.Name }} />
            </td>
            <td className='search-results-location'>
                <div className='search-results-location-text'>
                    <p style={{ marginBottom: "0" }}>{result.Location}</p>
                </div>
            </td>
            <td className='search-results-project-name'>
                <div dangerouslySetInnerHTML={{ __html: result.ProjectName }} />
            </td>
            <td className='search-results-type'>
                <div className='task-type-icon' title={icon.iconTitle}>
                    {icon.iconImage}
                </div>
            </td>
            <td className='search-results-members'>
                {result.Members && <ViewMembersPanelNew UserID={result.OwnerId} members={result.Members}></ViewMembersPanelNew>}
            </td>
            <td className='search-results-created'>
                {result.Days} days ago
            </td>
            <td className='search-results-lastmod'>
                {result.Doc ? '-' : result.DaysUpdated + ' days ago'}
            </td>
            <td className='search-results-view-action'>
                <button type='button' className='action-button view' title="View" onClick={() => viewResult()} />
            </td>
            {showDocumentViewer ? <DocumentViewer document={{ documentName: result.Name }} title={documentViewerType} showDocumentViewer={showDocumentViewer} setShowDocumentViewer={setShowDocumentViewer} /> : <></>}
            {showDocumentViewerPowerpoint ? <DocumentViewerPowerpoint assignmentId={result.Id} document={{ documentName: result.Name }} actionType={viewType} showDocumentViewer={showDocumentViewerPowerpoint} setShowDocumentViewer={setShowDocumentViewerPowerpoint} setUserActionType={setViewType} /> : <></>}
        </tr>
    )
}

SearchResultDetailedRow.propTypes = {
    result: PropTypes.shape({
        Link: PropTypes.string,
        Doc: PropTypes.bool,
        DocumentType: PropTypes.string,
        Type: PropTypes.string,
        Id: PropTypes.number,
        ProjectName: PropTypes.string,
        Name: PropTypes.string,
        Location: PropTypes.string,
        OwnerId: PropTypes.number,
        Members: PropTypes.array,
        Days: PropTypes.number,
        DaysUpdated: PropTypes.number
    })
};

export default SearchResultDetailedRow;
